import { createContext } from 'react'

export const ContestCreateContext = createContext(null)

export const ContestAcceptInvitation = createContext(null)
